module.exports = __webpack_public_path__ + "img/infiniteDomain.a4c4c40.svg";